import { Field } from 'Util/Query';

/** @namespace Bodypwa/Query/XsearchProducts/Query */
export class XsearchProductsQuery {
    getQuery(searchCriteria) {
        return new Field('xsearchProducts')
            .addArgument('search', 'String!', searchCriteria)
            .addFieldList(this._getSearchFields());
    }

    _addRedirectUrl() {
        return new Field('redirectUrl');
    }

    _getSearchFields() {
        return [
            this._getSearchItemsField(),
            this._addRedirectUrl(),
            'total_count'
        ];
    }

    _getSearchItemsField() {
        return new Field('items')
            .addFieldList(this._getSearchItemsFields());
    }

    _getSearchItemsFields() {
        return [
            'name',
            this._getSearchItemImageField(),
            this._getSearchItemPriceRangeField(),
            this._getSearchItemUrlField(),
            this._getSearchItemCategoriesField()
        ];
    }

    _getSearchItemCategoriesField() {
        return new Field('categories')
            .addFieldList(this._getSearchItemCategoriesFields());
    }

    _getSearchItemCategoriesFields() {
        return [
            'uid',
            'name',
            'image',
            'level',
            'url_path',
            'url_suffix'
        ];
    }

    _getSearchItemUrlField() {
        return new Field('url_rewrites')
            .addField('url');
    }

    _getSearchItemImageField() {
        return new Field('thumbnail')
            .addFieldList(this._getSearchItemImageFields());
    }

    _getSearchItemImageFields() {
        return [
            'label',
            'url',
            'overlay_disable'
        ];
    }

    _getSearchItemPriceRangeField() {
        return new Field('price_range')
            .addFieldList(this._getSearchItemPriceRangeFields());
    }

    _getSearchItemPriceRangeFields() {
        return [
            this._getSearchItemMaximumPriceField(),
            this._getSearchItemMinimumPriceField()
        ];
    }

    _getSearchItemMaximumPriceField() {
        return new Field('maximum_price')
            .addFieldList(this._getSearchItemPricesFields());
    }

    _getSearchItemMinimumPriceField() {
        return new Field('minimum_price')
            .addFieldList(this._getSearchItemPricesFields());
    }

    _getSearchItemPricesFields() {
        return [
            this._getSearchItemDefaultPriceField(),
            this._getSearchItemDefaultFinalPriceField(),
            this._getSearchItemDefaultFinalPriceExclTaxField(),
            this._getSearchItemFinalPriceField(),
            this._getSearchItemFinalPriceExclTaxField(),
            this._getSearchItemRegularPriceField(),
            this._getSearchItemRegularPriceExclTaxField(),
            this._getSearchItemDiscountField()
        ];
    }

    _getSearchItemDefaultPriceField() {
        return new Field('default_price')
            .addFieldList(this._getSearchItemPriceFields());
    }

    _getSearchItemDefaultFinalPriceField() {
        return new Field('default_final_price')
            .addFieldList(this._getSearchItemPriceFields());
    }

    _getSearchItemDefaultFinalPriceExclTaxField() {
        return new Field('default_final_price_excl_tax')
            .addFieldList(this._getSearchItemPriceFields());
    }

    _getSearchItemFinalPriceField() {
        return new Field('final_price')
            .addFieldList(this._getSearchItemPriceFields());
    }

    _getSearchItemFinalPriceExclTaxField() {
        return new Field('final_price_excl_tax')
            .addFieldList(this._getSearchItemPriceFields());
    }

    _getSearchItemRegularPriceField() {
        return new Field('regular_price')
            .addFieldList(this._getSearchItemPriceFields());
    }

    _getSearchItemRegularPriceExclTaxField() {
        return new Field('regular_price_excl_tax')
            .addFieldList(this._getSearchItemPriceFields());
    }

    _getSearchItemPriceFields() {
        return [
            'value',
            'currency'
        ];
    }

    _getSearchItemDiscountField() {
        return new Field('discount')
            .addFieldList(this._getSearchItemDiscountFields());
    }

    _getSearchItemDiscountFields() {
        return [
            'amount_off',
            'percent_off'
        ];
    }
}

export default new XsearchProductsQuery();
